import SectionHeading from "@/pages/home/components/SectionHeading";
import { opinions } from "@/mocks/opinions";
import { liveComments } from "@/mocks/community";

const sideConfig = [
  {
    key: "正方",
    label: "支持方",
    hint: "认为证据尚不充分，应先补齐信息再判断",
    badge: "bg-secondary-100 text-secondary-900",
    bar: "bg-secondary-500",
  },
  {
    key: "反方",
    label: "质疑方",
    hint: "认为既有材料已能说明问题，无需等待",
    badge: "bg-accent-100 text-accent-800",
    bar: "bg-accent-500",
  },
];

export default function Opinions() {
  return (
    <section id="opinions" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-shell mx-auto">
        <SectionHeading
          index="05"
          eyebrow="观点碰撞"
          title="同一件事，两种读法，都在这里说"
          desc="我们不给结论，只把不同立场的代表性观点摆在一起，你可以同意，也可以反驳。"
          actionLabel="进入社区"
          actionHref="#trending"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {sideConfig.map((side) => {
            const members = opinions.filter((o) => o.side === side.key);
            return (
              <div
                key={side.key}
                className="rounded-lg border border-background-200/80 bg-background-100/40 p-5 md:p-6"
              >
                <div className="flex items-center gap-3">
                  <span className={`h-6 w-1.5 rounded-full ${side.bar}`} />
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="font-heading text-lg font-bold text-foreground-950">
                        {side.label}
                      </h3>
                      <span className={`rounded-full px-2 py-0.5 text-[11px] ${side.badge}`}>
                        {side.key}
                      </span>
                    </div>
                    <p className="mt-0.5 text-xs text-foreground-400">{side.hint}</p>
                  </div>
                </div>

                <div className="mt-5 space-y-4">
                  {members.map((m) => (
                    <div
                      key={m.id}
                      className="rounded-md border border-background-200/70 bg-background-50 p-4"
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                          <img
                            src={m.avatar}
                            alt={`${m.name} 观点头像`}
                            title="黑料看点 观点碰撞"
                            className="w-full h-full object-cover object-top"
                          />
                        </div>
                        <div className="min-w-0">
                          <div className="text-sm font-medium text-foreground-900 truncate">
                            {m.name}
                          </div>
                          <div className="text-[11px] text-foreground-400">{m.role}</div>
                        </div>
                      </div>
                      <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                        “{m.quote}”
                      </p>
                      <div className="mt-3 flex items-center gap-4 text-[11px] text-foreground-400">
                        <button
                          type="button"
                          className="flex items-center gap-1 hover:text-accent-600 transition-colors cursor-pointer"
                        >
                          <i className="ri-heart-line" />
                          {m.likes}
                        </button>
                        <button
                          type="button"
                          className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer"
                        >
                          <i className="ri-chat-3-line" />
                          回复
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-6 md:mt-8 rounded-lg border border-background-200/80 bg-background-100/40 p-5 md:p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-float-slow" />
              <h3 className="font-heading text-base font-bold text-foreground-950">实时讨论</h3>
            </div>
            <span className="text-xs text-foreground-400">共 486 条 · 持续更新</span>
          </div>

          <ul className="mt-4 divide-y divide-background-200/70">
            {liveComments.map((c) => (
              <li key={c.id} className="flex items-start gap-3 py-3.5">
                <span className="w-9 h-9 rounded-full bg-secondary-100 text-secondary-800 flex items-center justify-center shrink-0 text-sm">
                  {c.name.slice(0, 1)}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 text-xs">
                    <span className="text-foreground-800 font-medium">{c.name}</span>
                    <span className="text-foreground-300">· {c.time}</span>
                  </div>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{c.text}</p>
                </div>
                <button
                  type="button"
                  className="flex items-center gap-1 text-[11px] text-foreground-400 hover:text-accent-600 transition-colors shrink-0 cursor-pointer"
                >
                  <i className="ri-heart-line" />
                  {c.likes}
                </button>
              </li>
            ))}
          </ul>

          <div className="mt-4 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <div className="flex-1 flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-2.5">
              <i className="ri-edit-2-line text-foreground-400 text-sm" />
              <span className="text-sm text-foreground-400">说说你的看法，先登录后发言</span>
            </div>
            <button
              type="button"
              className="whitespace-nowrap rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2.5 transition-colors cursor-pointer"
            >
              参与讨论
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}